import React from 'react'
import classes from '../styles/style.module.css'

const HubbleBlogFilter = () => {
    return (
        <div className={classes.filterContainer}>
            <div className={classes.filterItem}>
                همه
            </div>
            {/* <div className={classes.filterItem}>
                آرشیو
            </div> */}
        </div>
    )
}

export default HubbleBlogFilter